module.exports = __webpack_public_path__ + "static/media/lattes-icone.288bc0c0.png";